import { useContext, useState } from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import './lump.css';


function Lump() {

    const {data, loading, error, isBY, isRU, isLocal} = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);

    let urlPrefix = "/images/";
    if (isLocal) urlPrefix = "https://sushi-tunec.com" + urlPrefix;



        const section = data.sectionsdata.find(s => s.nick === 'lump');
        const paragraphs = section ? section.paragraphsdata : [];

        return (
            <motion.section
                id="lump"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.5, delay: 0.25 }}
                onAnimationComplete={() => {
                    setShowItems(true);
                }}
            >
                <div className="inner_block">

                    <h2>{section.title}</h2>

                    {
                        paragraphs.slice(0, 1).map((par) => (

                            <>

                                <h3>{par.title}</h3>
                                {par.text}


                                {par.galerydata.length > 0  && (
                                    <div className="galery">

                                        {
                                                par.galerydata.map((gal, index) => (

                                                    <motion.div
                                                        key={index}
                                                        initial={{ opacity: 0, y: 10, scale: 0.5 }}
                                                        animate={ showItems ? { opacity: 1, y: 0, scale: 1 } : {}}
                                                        transition={{ delay: index * 0.3, duration: 0.3 }}
                                                        className="galery_item"
                                                    >
                                                        <img src={urlPrefix + gal.image} />

                                                        {
                                                        gal.text.map((line, index2) => (
                                                        <span key={index2}>{line}<br /></span>
                                                        ))
                                                        }

                                                    </motion.div>

                                                    ))
                                        }
                                    </div>
                                )}

                            </>

                        ))
                    }


                </div>
            </motion.section>
        )

    }

export default Lump;